"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerCard = void 0;

var tslib_1 = require("tslib");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icons_1 = require("@hopin-team/ui-icons");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var centered_grid_1 = require("./styled/centered-grid");

var clamped_text_1 = require("./styled/clamped-text");

var link_1 = require("./styled/link");

var root_1 = require("./styled/root");

var styled_avatar_1 = require("./styled/styled-avatar");

var styled_box_1 = require("./styled/styled-box");

var SpeakerCard = function SpeakerCard(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      name = _a.name,
      headline = _a.headline,
      institution = _a.institution,
      bio = _a.bio,
      linkedin = _a.linkedin,
      twitter = _a.twitter,
      website = _a.website,
      pictureUrl = _a.pictureUrl,
      speakerProfileUrl = _a.speakerProfileUrl;
  var rootClasses = ui_helper_deep_branding_1.useEscapeClasses({
    block: 'SpeakerCard',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses
  }, react_1.default.createElement(styled_box_1.StyledBox, {
    level: "low",
    cornerRadius: "xl",
    border: "grey-200",
    p: 3
  }, react_1.default.createElement(centered_grid_1.CenteredGrid, {
    gridRowGap: ui_symbols_1.calcSpace(2)
  }, react_1.default.createElement(styled_avatar_1.StyledAvatar, {
    alt: name + "'s Avatar",
    src: pictureUrl,
    scale: 11
  }), react_1.default.createElement(ui_text_1.Text, {
    pattern: "labelOne",
    color: "grey-900"
  }, name), headline && institution && react_1.default.createElement(ui_text_1.Text, {
    pattern: "labelOne",
    color: "grey-700"
  }, headline + ", " + institution), react_1.default.createElement(ui_flex_1.Flex, {
    justifyContent: "center"
  }, linkedin && react_1.default.createElement(link_1.Link, {
    href: linkedin
  }, react_1.default.createElement(ui_icons_1.Icon, {
    icon: "linkedin",
    description: "Linkedin URL",
    title: "Linkedin URL",
    width: "12",
    height: "12"
  })), twitter && react_1.default.createElement(link_1.Link, {
    href: twitter
  }, react_1.default.createElement(ui_icons_1.Icon, {
    icon: "twitter",
    description: "Twitter URL",
    title: "Twitter URL",
    width: "12",
    height: "12"
  })), website && react_1.default.createElement(link_1.Link, {
    href: website
  }, react_1.default.createElement(ui_icons_1.Icon, {
    icon: "website",
    description: "Website URL",
    title: "Website URL",
    width: "12",
    height: "12"
  }))), bio && react_1.default.createElement(clamped_text_1.ClampedText, {
    pattern: "labelOne",
    color: "grey-700"
  }, bio), speakerProfileUrl && react_1.default.createElement(ui_button_1.Button, {
    pattern: "secondary",
    isOutlined: true,
    href: speakerProfileUrl
  }, "View profile"))));
};

var SpeakerCardWithSpace = ui_helper_with_space_1.withSpace(SpeakerCard);
exports.SpeakerCard = SpeakerCardWithSpace;